import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import i18next from 'i18next';
import { getSources, Source } from 'config/services/sources.service';
import { HERO_PLAN_MAESTRO, heroImageForSource } from 'constants/heroImages';
import PageHero from '~components/PageHero';
import SourceDashboard from './components/SourceDashboard';
import SourceTabs from './components/SourceTabs';
import styles from './styles.module.scss';
import './i18n';

const SOURCE_PARAM = 'fuente';

const Home = () => {
    const [sources, setSources] = useState<Source[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const selectedId = Number(searchParams.get(SOURCE_PARAM)) || null;
    const selectedSource = sources.find(s => s.id === selectedId);

    const selectSource = (sourceId: number | null) => {
        const params = new URLSearchParams(searchParams);
        if (sourceId === null) {
            params.delete(SOURCE_PARAM);
        } else {
            params.set(SOURCE_PARAM, String(sourceId));
        }
        setSearchParams(params, { replace: true });
    };

    useEffect(() => {
        getSources().then(res => setSources(res.ok && res.data ? res.data : []));
    }, []);

    return (
        <div className={styles.listContainer}>
            <PageHero
                variant="image"
                height={440}
                image={selectedSource ? heroImageForSource(selectedSource.nameEs) : HERO_PLAN_MAESTRO}
                title={i18next.t('home:title')}
                subtitle={i18next.t('home:subtitle')}
                tabs={<SourceTabs sources={sources} selectedId={selectedId} onSelect={selectSource} />}
            />
            <SourceDashboard sourceId={selectedId} />
        </div>
    );
};

export default Home;
